function D(t) {
  return t instanceof Date && !isNaN(t);
}
function r(t) {
  let e = /* @__PURE__ */ new Date(), a = new Date(t), n = e.getFullYear() - a.getFullYear(), i = e.getMonth() - a.getMonth();
  return (i < 0 || i === 0 && e.getDate() < a.getDate()) && n--, n;
}
function l(t) {
  let e = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ new Date(`${e - t}-06-15`);
}
class g {
  static MILLISECONDS_PER_SECOND = 1e3;
  static SECONDS_PER_MINUTE = 60;
  static MINUTES_PER_HOUR = 60;
}
export {
  g as Duration,
  r as getAge,
  l as getDateFromAge,
  D as isValidDate
};
